var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    stroke: "rgba(237, 112, 55, 1)",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4693 20.9703L13.5293 22.0303L20.0598 15.4968L13.5298 8.96983L12.4693 10.0308L17.9388 15.4973L12.4693 20.9703Z",
    fill: "#ED7037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreActive);
export default __webpack_public_path__ + "static/media/more-active.40843bb96fd1b2bed2b7c09cd3d29925.svg";
export { ForwardRef as ReactComponent };